module.exports = __webpack_public_path__ + "static/media/fee.3b687f28.png";